<template>
    <div>
        <form class="xcard" @submit.prevent="validarCampos" style="margin-top:0;" novalidate>
            <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>            
            <h3 class="text-center"> Registrar Nuevo Usuario para el Sistema </h3>
            <p class="text-center text-primary" style="margin-bottom:0"> <small class="center-block"> Los campos con un asterisco <span class="text-danger">*</span> son obligatorios </small> </p>
            
            <p class="text-primary"> <b>Datos personales</b> </p>
            <!-- persona: {{ persona }} -->
            <p class="mb-1 purple--text"> Primero busque por carnet si existe en el sistema de talento humano: </p>
            <div class="row">
                <div class="col-sm-6"> 
                    <div class="row">
                        <div class="col-6 col-sm-7">
                            <v-text-field v-model="persona.num_doc" :loading="buscando" :disabled="buscando" clearable outlined dense label="Documento de identidad:" append-icon="mdi-file-find" @click:append="buscarTalento">
                            </v-text-field>
                        </div>
                        <div class="col-6 col-sm-5">
                            <v-btn class="full-width" tile block color="purple" outlined @click="buscarTalento">Verificar</v-btn>
                        </div>
                    </div>
                    
                    <!-- <div class="form-group" :class="{'has-error': validation.hasError('persona.num_doc')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"> <span class="text-danger">*</span> Documento:</div>
                            <input type="text" v-model.trim="persona.num_doc" class="form-control" placeholder="Documento de identidad sin extension">
                            <div class="input-group-addon"> 
                                <v-btn size="xs" dense small>  </v-btn>
                            </div>
                        </div>
                        <div class="error" v-if="validation.hasError('persona.num_doc')"> {{validation.firstError('persona.num_doc')}} </div>
                    </div> -->
                    <template v-if="existe_in_talento"> 
                        <div class="form-group" :class="{'has-error': validation.hasError('persona.iddepartamento')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon"> Expedido: </div>
                                <Departamentos :model="persona" ref="refDepartamentos" />
                            </div>
                            <div class="error" v-if="validation.hasError('persona.iddepartamento')"> {{validation.firstError('persona.iddepartamento')}} </div>
                        </div>
                        <div class="form-group" :class="{'has-error': validation.hasError('persona.nombres')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon"> <span class="text-danger">*</span> Nombres:</div>
                                <input type="text" v-model.trim="persona.nombres" class="form-control" placeholder="Primer y segundo nombre">
                            </div>
                            <div class="error" v-if="validation.hasError('persona.nombres')"> {{validation.firstError('persona.nombres')}} </div>
                        </div>
                        <div class="form-group" :class="{'has-error': validation.hasError('persona.pri_apellido')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon"> <span class="text-danger">*</span> Apellido 1:</div>
                                <input type="text" v-model.trim="persona.pri_apellido" class="form-control" placeholder="Primer apellido">
                            </div>
                            <div class="error" v-if="validation.hasError('persona.pri_apellido')"> {{validation.firstError('persona.pri_apellido')}} </div>
                        </div>
                        <div class="form-group" :class="{'has-error': validation.hasError('persona.seg_apellido')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon"> Apellido 2:</div>
                                <input type="text" v-model.trim="persona.seg_apellido" class="form-control" placeholder="Segundo apellido (Si tiene)">
                            </div>
                            <div class="error" v-if="validation.hasError('persona.seg_apellido')"> {{validation.firstError('persona.seg_apellido')}} </div>
                        </div>
                        <div class="form-group" :class="{'has-error': validation.hasError('persona.email')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon"> <span class="text-danger">*</span> Correo:</div>
                                <input type="text" v-model.trim="persona.email" class="form-control" placeholder="Correo electronico">
                            </div>
                            <div class="error" v-if="validation.hasError('persona.email')"> {{validation.firstError('persona.email')}} </div>
                        </div>
                        <!-- <div class="form-group" :class="{'has-error': validation.hasError('persona.tipo')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon"> <span class="text-danger">*</span> Tipo:</div>
                                <select v-model.trim="persona.tipo" class="form-control" >
                                    <option value="E">Estudiante</option>
                                    <option value="D">Docente</option>
                                </select>
                            </div>
                            <div class="error" v-if="validation.hasError('persona.tipo')"> {{validation.firstError('persona.tipo')}} </div>
                        </div> -->
                        <div class="form-group" :class="{'has-error': validation.hasError('persona.sexo')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon"> <span class="text-danger">*</span> Sexo:</div>
                                <select v-model.trim="persona.sexo" class="form-control" >
                                    <option value="F">Mujer</option>
                                    <option value="M">Hombre</option>
                                    <option value="O">Otros</option>
                                </select>
                            </div>
                            <div class="error" v-if="validation.hasError('persona.sexo')"> {{validation.firstError('persona.sexo')}} </div>
                        </div>
                        <div class="form-group" :class="{'has-error': validation.hasError('persona.diestro')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon"> <span class="text-danger">*</span> Diestro:</div>
                                <select v-model.trim="persona.diestro" class="form-control" >
                                    <option value="true">Si</option>
                                    <option value="false">No</option>
                                </select>
                            </div>
                            <div class="error" v-if="validation.hasError('persona.diestro')"> {{validation.firstError('persona.diestro')}} </div>
                        </div>
                        <div class="form-group" :class="{'has-error': validation.hasError('persona.profesiones')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon"><span class="text-danger">*</span> Profesiones</div>
                                <Profesiones :model="persona" v-bind:multiple="true" ref="refProfesiones"/>
                            </div>
                            <div class="error" v-if="validation.hasError('persona.profesiones')"> {{validation.firstError('persona.profesiones')}} </div>
                        </div>

                        <Menus />
                    </template>
                </div>





                <div class="col-sm-6" v-if="existe_in_talento">
                    <div class="form-group" :class="{'has-error': validation.hasError('persona.idpais')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon">Pais</div>
                            <Paises :model="persona"/>
                        </div>
                        <div class="error" v-if="validation.hasError('persona.idpais')"> {{validation.firstError('persona.idpais')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('persona.idinstitucion')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon">Institucion</div>
                            <Universidades :model="persona"/>
                        </div>
                        <div> <small class="text-primary">Institucion o Universidad de egreso.</small> </div>
                        <div class="error" v-if="validation.hasError('persona.idinstitucion')"> {{validation.firstError('persona.idinstitucion')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('persona.idciudad')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon">Ciudad</div>
                            <Ciudades :model="persona"/>
                        </div>
                        <div class="error" v-if="validation.hasError('persona.idciudad')"> {{validation.firstError('persona.idciudad')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('persona.usuario_moodle')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon">Usuario Moodle</div>
                            <input type="text" v-model.trim="persona.usuario_moodle" class="form-control">
                        </div>
                        <div class="error" v-if="validation.hasError('persona.usuario_moodle')"> {{validation.firstError('persona.usuario_moodle')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('persona.clave_moodle')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon">Clave Moodle</div>
                            <input type="text" v-model.trim="persona.clave_moodle" class="form-control">
                        </div>
                        <div class="error" v-if="validation.hasError('persona.clave_moodle')"> {{validation.firstError('persona.clave_moodle')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('persona.telefono1')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon">Telefono 1</div>
                            <input type="text" v-model.trim="persona.telefono1" class="form-control">
                        </div>
                        <div class="error" v-if="validation.hasError('persona.telefono1')"> {{validation.firstError('persona.telefono1')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('persona.telefono2')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon">Telefono 2</div>
                            <input type="text" v-model.trim="persona.telefono2" class="form-control">
                        </div>
                        <div class="error" v-if="validation.hasError('persona.telefono2')"> {{validation.firstError('persona.telefono2')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('persona.domicilio')}">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon">Domicilio</div>
                            <input type="text" v-model.trim="persona.domicilio" class="form-control">
                        </div>
                        <div class="error" v-if="validation.hasError('persona.domicilio')"> {{validation.firstError('persona.domicilio')}} </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group input-group-sm" :class="{'has-error': validation.hasError('persona.fecha_nac')}">
                            <div class="input-group-addon">Fecha de nac.</div>
                            <Fecha :model="persona" valueto="fecha_nac" ref="refFecha"/>
                        </div>
                        <div class="error" v-if="validation.hasError('persona.fecha_nac')"> {{validation.firstError('persona.fecha_nac')}} </div>
                    </div>

                </div>
            </div>

            <template v-if="existe_in_talento">
                <p class="text-primary"> <b>Datos del usuario con acceso al sistema</b> </p>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group" :class="{'has-error': validation.hasError('usuario.login')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon"> <span class="text-danger">*</span> Usuario:</div>
                                <input type="text" v-model.trim="usuario.login" class="form-control" placeholder="Login de acceso a este Sistema">
                            </div>
                            <div class="error" v-if="validation.hasError('usuario.login')"> {{validation.firstError('usuario.login')}} </div>
                        </div>
                        <div class="form-group" :class="{'has-error': validation.hasError('usuario.clave')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon"> <span class="text-danger">*</span> Clave:</div>
                                <input type="text" v-model.trim="usuario.clave" class="form-control" placeholder="Clave de acceso a este Sistema">
                            </div>
                            <div class="error" v-if="validation.hasError('usuario.clave')"> {{validation.firstError('usuario.clave')}} </div>
                        </div>
                    </div>
    
                    <div class="col-sm-6">
                        <div class="form-group" :class="{'has-error': validation.hasError('usuario.correo_corp')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon">Correo Corp:</div>
                                <input type="text" v-model.trim="usuario.correo_corp" class="form-control" placeholder="Correo corporativo">
                            </div>
                            <div class="error" v-if="validation.hasError('usuario.correo_corp')"> {{validation.firstError('usuario.correo_corp')}} </div>
                        </div>
                        <div class="form-group" :class="{'has-error': validation.hasError('usuario.observacion')}">
                            <div class="input-group input-group-sm">
                                <div class="input-group-addon">Observacion:</div>
                                <input type="text" v-model.trim="usuario.observacion" class="form-control" placeholder="Alguna observacion">
                            </div>
                            <div class="error" v-if="validation.hasError('usuario.observacion')"> {{validation.firstError('usuario.observacion')}} </div>
                        </div>
                    </div>
                </div>
    
                
                <p v-if="validation.hasError('cargos')" class="text-danger" style="margin-bottom:0">Indique los cargos y sedes </p>
                <Asignar :model="cargos"/>
    
                <Alertas ref="alertar" />
                <p class="text-center"> {{msg}} </p>
                <button :disabled="!activo" type="submit" class="btn btn-sm btn-azul center-block"> Aceptar </button>
            </template>
        </form>

        <notifications group="auth" position="bottom right" />
    </div>
</template>

<script>
import { Validator } from 'simple-vue-validator';
import gql from 'graphql-tag'
import Profesiones from '@/components/AProfesiones.vue'
import Departamentos from '@/components/ADepartamentos.vue'
import Paises from '@/components/APaises.vue'
import Universidades from '@/components/AUniversidades.vue'
import Ciudades from '@/components/ACiudades.vue'
import Fecha from '@/components/AFecha.vue'
import Asignar from '@/components/AAsignarCargoAdd.vue'
import Alertas from '@/components/AAlertas.vue'
import Menus from '@/components/AMenus.vue'
import { parseJsonError } from '@/components/Utils.js'

export default {
    data() {
        return {
            activo: true,
            msg: '',
            universidades: [],
            postgrados: [],
            sedes: [],
            gestiones: [],
            persona: {
                num_doc: null,
                nombres: null,
                pri_apellido: null,
                email: null,
                sexo: null,
                tipo: 'P',
                diestro: true,
                idprofesion: null,
                profesiones: [],
                
                grados: [],
                idpais: null,
                iddepartamento: null,
                idinstitucion: null,
                idciudad: null,
                contacto: null,
                datos_laborales: null,
                clave_moodle: null,
                usuario_moodle: null,
                est_civil: null,
                fecha_nac: null,
                telefono2: null,
                telefono1:null,
                domicilio: null,
                seg_apellido: null,
            },
            usuario:{
                login: null,
                clave: null,
                correo_corp: null,
                observacion: null,
                foto:"userdefault",
            },
            cargos:[],
            existe_in_talento: false,
            buscando: false,
        };
    },
    components:{Profesiones,Departamentos,Paises,Universidades,Ciudades,Fecha,Asignar,Alertas,Menus},
    validators: {
        'persona.num_doc'(value){ return Validator.value(value).required().minLength(7); },
        'persona.nombres'(value){ return Validator.value(value).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$").required().minLength(2); },
        'persona.pri_apellido'(value){ return Validator.value(value).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$").required().minLength(2); },
        'persona.email'(value){ return Validator.value(value).required().email(); },
        'persona.sexo'(value){ return Validator.value(value).required(); },
        'persona.tipo'(value){ return Validator.value(value).required(); },
        'persona.diestro'(value){ return Validator.value(value).required(); },
        'persona.profesiones'(value){ return Validator.value(value).required(); },

        'persona.seg_apellido'(value){ return Validator.value(value).minLength(0).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$"); },
        'persona.domicilio'(value){ return Validator.value(value).minLength(0); },
        // 'persona.domicilio'(value){ return Validator.value(value).minLength(0).regex("^([a-zñáéíóúA-ZÁÉÍÓÚÑ 0-9])([a-zñáéíóúA-ZÁÉÍÓÚÑ 0-9 % # ° / : , ' \" “ ” - . _ & ()]+)$"); },

        'usuario.login'(value){ return Validator.value(value).required().minLength(5); },
        'usuario.clave'(value){ return Validator.value(value).required().minLength(5); },
        'cargos'(value){ return Validator.value(value).required(); },
    },
    watch:{
        persona: { deep:true,handler(){ window.sessionStorage.setItem( 'xpersona',JSON.stringify(this.persona) ); } },
        usuario: { deep:true,handler(){ window.sessionStorage.setItem( 'xusuario',JSON.stringify(this.usuario) ); } },
        'persona.idprofesion': function(){ this.setProfesiones() },

        'persona.nombres': function(){ this.crearClave() },
        'persona.pri_apellido': function(){ this.crearClave() },
        'persona.seg_apellido': function(){ this.crearClave() },
        'persona.fecha_nac': function(){ this.crearClave() },
        'persona.num_doc': function(){
            let unidad = this.$store.state.CARGO.sede.unidad_negocio;
            if(unidad != 14){
                this.existe_in_talento = false;
            }
            this.clearDataRRHH(); 
            this.crearLogin();
            this.crearClave();
        },
        // 'persona.iddepartamento': function(){ this.crearClave() },
    },
    methods:{ 
        crearLogin(){
            var car = this.persona.num_doc;
            var ci = "";
            var dep = this.persona.iddepartamento;
            if( car && car.length > 0 ) ci = this.persona.num_doc;
            if( dep ) ci = ci+this.persona.iddepartamento.extension;
            this.usuario.login = ci;
            this.persona.usuario_moodle = ci;
        },
        crearClave(fnac = null){ 
            let f = this.persona.fecha_nac;
            if(fnac) f = fnac;  
            const a = this.persona.nombres;
            const ap = this.persona.pri_apellido;
            const am = this.persona.seg_apellido;
            const logi = this.$generarCodigoPersona(f, a, ap, am);
            this.usuario.clave = logi;
            this.persona.clave_moodle = logi; 
        },
        validarCampos(){
            // this.$refs.alertar.reset();
            this.parseBoolean();
            this.$validate().then((success) => {
                var obj = window.Object.assign( {},this.persona );
                var obj2 = window.Object.assign( {},this.usuario );
                if (success) {
                    if( obj.iddepartamento ) obj.iddepartamento = obj.iddepartamento.id;
                    if( obj.idpais ) obj.idpais = obj.idpais.id;
                    if( obj.iduniversidad ) obj.idinstitucion = obj.iduniversidad.id;
                    if( obj.idciudad ) obj.idciudad = obj.idciudad.id;
                    if(obj.idprofesion){
                        this.setProfesiones()
                    }
                    delete obj.iduniversidad;
                    delete obj.idprofesion;
                    delete obj.fecha;
                    // estas acciones van en par, set el objeto para luego limpiar campos nulos
                    this.$store.state.obj = obj;
                    this.$store.dispatch('quitarNulos');

                    this.$store.state.obj = obj2;
                    this.$store.dispatch('quitarNulos');

                    this.activo = false;
                    this.$refs.alertar.cargando();
                    // window.console.log( "SSSSS",window.stringifyObject(obj),window.stringifyObject(obj2),window.stringifyObject(this.cargos) );
                    this.enviarDatos( obj,obj2 );
                }else{
                    // window.console.log( "HHHHH",window.stringifyObject(obj),window.stringifyObject(obj2),window.stringifyObject(this.cargos) );
                    this.$refs.alertar.invalido();
                }
            });
        },
        setProfesiones(){
            if( this.persona.idprofesion == null ) return;
            this.persona.profesiones = [];
            var vue = this;
            vue.persona.idprofesion.forEach(function(e){ vue.persona.profesiones.push( e.id ); })
        },
        parseBoolean(){
            if( this.persona.diestro == "true") this.persona.diestro = true;
            else this.persona.diestro = false;
        },
        async enviarDatos( obj,obj2 ){
            var vue = this;
            var d = [];
            this.cargos.forEach( function(e){
                d.push( { idcargo: e.idcargo, idsede: e.idsede} );
            })
            var sql = gql`mutation{ createUsuarioPersonaCargo(input:{ persona:${window.stringifyObject(obj)},usuario:${window.stringifyObject(obj2)},cargos:${window.stringifyObject(d)} }){ok,errors{message}} }`

            this.$apollo.mutate({
                mutation: sql, 
            }).then((data) => {
                // window.console.log(data.data.createUsuarioPersonaCargo);
                if( data.data.createUsuarioPersonaCargo.ok ){
                    vue.$refs.alertar.success();
                    window.sessionStorage.setItem( 'xpersona',null );
                    window.sessionStorage.setItem( 'xusuario',null );
                }else{
                    var errores = JSON.stringify(data.data.createUsuarioPersonaCargo.errors);
                    var obj = JSON.parse( errores );
                    var vals = '';
                    obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
                    //vue.msg = vals;
                    vue.msg = '';
                    // window.console.log( "ERRORESSSSSSS: ",vals );
                    vue.activo = true;
                    vue.$refs.alertar.invalido( vals );
                }
                
            }).catch((error) => {
                vue.$refs.alertar.invalido();
                this.activo = true;
                window.console.error(error);
                this.$notify( parseJsonError( error ) )
            })

        },

        clearDataRRHH(){
            this.persona.nombres = '';
            this.persona.pri_apellido = '';
            this.persona.seg_apellido = '';
            this.persona.email = '';
            this.persona.sexo = '';
            this.persona.domicilio = '';
            this.persona.telefono1 = '';
            this.persona.fecha_nac = '';
            this.persona.iddepartamento = null;
            this.persona.idprofesion = null;
        },
        async buscarTalento(){
            if(!this.persona.num_doc) return;
            const url = process.env.VUE_APP_RRHH+'/empleados/validar?nro_ci='+this.persona.num_doc
            const tokenStatic = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaXN0ZW1hIjoic2lzdGVtYV9wb3J0YWwiLCJpYXQiOjE3Mjg1MDgxNTAsImV4cCI6MzE3MjcyOTUwNTUwfQ.mo9Y8O-B4-AIoMt2rHKqVUZrDy_Z5oBZAn1VrrMLFzg';
            const h = {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${tokenStatic}`,
                    'Content-Type': 'application/json'
                }
            }
            this.existe_in_talento = false;
            this.buscando = true;
            const res = await fetch(url,h).then((response) => response.json()).then((result) =>  (result)).catch((error) =>  (error));
            let cvigente = res.vigente? 'success': 'red';
            let mensaje = res.message? res.message: res.mensaje;
            this.existe_in_talento = res.vigente? true: false;
            
            this.$root.$notify.show(mensaje, { color: cvigente, x: 'right' });
            
            this.clearDataRRHH();
            const vue = this;

            if(res.datos){
                window.console.log('talentoooo', res.datos);
                this.persona.nombres = res.datos.primerNombre;
                if(res.datos.otrosNombres) this.persona.nombres += ' '+res.datos.otrosNombres;
                this.persona.pri_apellido = res.datos.apellidoPaterno;
                this.persona.seg_apellido = res.datos.apellidoMaterno;
                this.persona.email = res.datos.correoElectronico;
                this.persona.sexo = res.datos.sexo;
                this.persona.domicilio = res.datos.direccion;
                this.persona.telefono1 = res.datos.celular; 
                setTimeout(()=>{
                    vue.$refs.refDepartamentos.findCi(res.datos.expedidoCi);
                    vue.$refs.refProfesiones.findPf(res.datos.profesionOcupacion);
                    vue.$refs.refFecha.findFn(res.datos.fechaNacimiento);
                    vue.crearClave(res.datos.fechaNacimiento)
                },300)
            }
            
            this.buscando = false;
            
        }
    },
    beforeDestroy(){
        // window.console.log( "DESTROYYYYYY" );
    },
    mounted(){
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        // window.console.log('unidad',unidad);
        
        if(unidad == 14){
            this.existe_in_talento = true;
        }
        /*var xp = sessionStorage.xpersona;
        var xu = sessionStorage.xusuario;
        if( xp != null ) this.persona = JSON.parse(xp);
        if( xu != null ) this.usuario = JSON.parse(xu);*/
    }                    

}
</script>